import { render, staticRenderFns } from "./helpSupport.vue?vue&type=template&id=4160f5a0&scoped=true&"
import script from "./helpSupport.vue?vue&type=script&lang=js&"
export * from "./helpSupport.vue?vue&type=script&lang=js&"
import style0 from "./helpSupport.vue?vue&type=style&index=0&id=4160f5a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4160f5a0",
  null
  
)

component.options.__file = "helpSupport.vue"
export default component.exports